type ITableBills = {
    data: any,
    headers: any[],
    loading?: boolean

}

const Table = (props: ITableBills) => {
    const { data, loading, headers } = props;

    const _renderColumn = (payload: any) => {
        if (payload instanceof Array) {
            return payload.map((item: any, index: any) => (
                <p key={`column-${index}-${index}`}>
                    {item}
                </p>
            ))
        }

        return <p>{payload}</p>
    }

    const _renderRow = (payload: any) => {
        if (payload instanceof Array) {
            return payload.map((item: any, index: any) => (
                <td key={`row-${index}`} className="px-3">
                    {_renderColumn(item)}
                </td>
            ))
        }

        if (payload instanceof Object) {
            return Object.keys(payload).map((key: any, index: any) => (
                <td key={`row-${index}-${index}`} className="px-3">
                    {_renderColumn(payload[key])}
                </td>
            ))
        }
    }

    // if (headers?.length === 0) return null;

    return (
        <div className='card-body py-5'>
            {/* begin::Table container */}
            <div className={`table-responsive ${loading ? 'table-loading-overlay' : ''}`}>
                {/* begin::Table */}
                <table className='table table-striped table-hover align-middle gs-0 gy-5'>
                    {/* begin::Table head */}
                    <thead>
                        <tr className="text-gray-400 fs-4">
                            {headers.map((item: any, index: any) => (
                                <th key={`${item}-${index}`} className="px-3 py-7 min-w-100px">
                                    {item}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    {/* end::Table head */}
                    {/* begin::Table body */}
                    <tbody className="fs-6 text-gray-800">
                        {data?.map((item: any, index: any) => (
                            <tr className="border-bottom" key={`${index}-${index + 1}`}>
                                {_renderRow(item.arrvalueitem)}
                            </tr>
                        ))}
                    </tbody>
                    {/* end::Table body */}
                </table>
                {/* end::Table */}

                {!loading && data.length === 0 ? (
                    <div className="text-center py-10">No hay ningun registro</div>
                ) : null}
            </div>
            {/* end::Table container */}
        </div>
    )

}

export default Table;